@if(app.customer.basket.data) {
<form #form="ngForm"
      method="post"
      [ngSwitch]="!!coupon">

    <div *ngSwitchCase="true">
        <p class="p2">
            {{'Voucher % has been applied' | translate : couponLabel}}
        </p>

        <action (click)="remove()"
                [status]="removeStatus"
                class="button-inline">{{ 'Click here to remove' | translate }}</action>
        <result class="block"
                [status]="removeStatus"></result>
    </div>

    <ng-container *ngSwitchDefault>
        <ng-container [ngSwitch]="showExpandableForm">
            <ng-container *ngSwitchCase="true">
                <div class="bg-col-51">

                    <expandable [expandableTitle]="'Promotional code' | translate"
                                expandableLayout="filled"
                                expandableId="couponForm">
                        <ng-container *ngTemplateOutlet="couponBody"></ng-container>
                    </expandable>
                </div>
            </ng-container>

            <ng-container *ngSwitchCase="false">
                <div class="p2 underline m-t-8 m-b-5 cursor-pointer"
                     [zippyOpen]="['couponForm']">
                    {{ 'Do you have a discount code? Enter here' | translate }}
                </div>

                <div class="hide-up-container">
                    <div class="ng-hide-animate hide-up hide-up-100"
                         [zippy]="['couponForm']">
                        <ng-container *ngTemplateOutlet="couponBody"></ng-container>
                    </div>
                </div>
            </ng-container>
        </ng-container>
    </ng-container>

    <ng-template #couponBody>
        <input-wrap class="m-t-2 block no-tick"
                    [required]="true">
            <input class="input bg-col-5"
                   type="text"
                   name="coupon"
                   [required]="true"
                   (keydown.enter)="submit()"
                   [(ngModel)]="data.coupon"
                   [muiInput]="'Enter promo code'| translate">
        </input-wrap>

        <div class="m-t-2">
            <div class="w-6 p-r-1">
                <action class="w-12 button"
                        (click)="submit()"
                        [status]="status">
                    {{ 'Apply' | translate}}
                </action>
            </div>
            <div class="w-6 p-l-1">
                <button class="w-12 button-1"
                        zippyToggle="couponForm">
                    {{ 'Cancel' | translate}}
                </button>
            </div>
        </div>

        <result [status]="status"></result>
    </ng-template>
</form>
}
